import { Component, Inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler, NullValidationHandler } from 'angular-oauth2-oidc';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { SignalRService } from './services/signalr/signal-rservice.service';
import { MENU_ITEMS } from './app-menu';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { trigger, state, style, animate, transition, group, query } from '@angular/animations';
import { BreadCrumbsService } from './services/NewFolder/bread-crumbs.service';
import { DialogService } from 'primeng/api';
import { MfChromeSupportComponent } from './framework/components/mf-chrome-support/mf-chrome-support.component';
import { appSettings } from './modules/shared/components/appSettings';
import { NbToastrService } from '@nebular/theme';

const STORAGE_KEY_REDIRECT = 'redirectUrl';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('routeAnimations', [
      //state('void', [
      //  style({ opacity: 0 }),
      //  animate('5000ms', style({ opacity: 1 }))
      //]),
      //transition('* => hidden', [
      //  animate('5000ms', style({ opacity: 0 }))
      //])
      //state('flyIn', style({ opacity: 0 })),
      //transition(':enter', [
      //  style({ transform: 'translateY(100%)' }),
      //  //animate('5s 300ms ease-in')
      //]),
      //transition('* => *', [
      //  group([
      //  style({ transform: 'translateY(0%)' }),
      //    animate('0.1s ease-out'),
      //  style({ transform: 'translateY(100%)' }),
      //    animate('0.1s 0.1s ease-in')
      //  ])
      //]),
      //transition(':leave', [
      //  animate('0.3s ease-out', style({ transform: 'translateX(100%)' }))
      //])
      //transition('* => *', [
      //  //group([
      //  //  query(':enter', style({ opacity: 0 })),
      //  //  query(':leave', [
      //  //    animate('1s', style({ opacity: 0 }))
      //  //  ]),
      //  //  query(':enter', [
      //  //    animate('1s', style({ opacity: 1 }))
      //  //  ])
      //  //])
      //  query(
      //    ':enter',
      //    [style({ opacity: 0 })],
      //    { optional: true }
      //  ),
      //  query(
      //    ':leave',
      //    [style({ opacity: 1 }), animate('0.3s', style({ opacity: 0 }))],
      //    { optional: true }
      //  ),
      //  query(
      //    ':enter',
      //    [style({ opacity: 0 }), animate('0.3s', style({ opacity: 1 }))],
      //    { optional: true }
      //  )
      //])
    ])
  ]
})


export class AppComponent {
  title = 'Southey';
  userProfile: object
  loadingRouteConfig: boolean;
  mainPanelClass: any = "main-panel";
  menu = MENU_ITEMS;
  constructor(private router: Router,
    private signalRService: SignalRService,
    public auth: IdentityAuthService,
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    private breadCrumbService: BreadCrumbsService,
    public dialogService?: DialogService,
    private messageService?: NbToastrService) {
    this.subscribeToEvents();

    this.auth.userOrganisationsObserver.subscribe(i => {
      this.setupMenu();
    })

    this.auth.currentOrganisationIdObserver.subscribe(i => {
      this.setupMenu();
    })

    this.setupMenu();

  }

  setupMenu() {
    this.menu.forEach(item => {
      if (item.data) {
        if (this.auth.hasAnyPermissionsArr(item.data))
          item.hidden = false;
        else item.hidden = true;
      }
      true
      if (item.children && item.children.length > 0) {
        item.children.forEach(nestedItem => {
          if (nestedItem.data) {
            if (this.auth.hasAnyPermissionsArr(nestedItem.data))
              nestedItem.hidden = false;
            else nestedItem.hidden = true;
          }
        });
      }

    })
  }
  public checkChrome() {
    //if (this.auth.hasAnyPermissions(this.auth.Permissions.RequisitionApproval, this.auth.Permissions.RequisitionCreate, this.auth.Permissions.StockRequisition,
    //  this.auth.Permissions.ProcurementApproval,
    //  this.auth.Permissions.InvoicingModule, this.auth.Permissions.InvoicingEdit)) {
      var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
      if (!isChrome) {
        const ref = this.dialogService.open(MfChromeSupportComponent, {
          data: {

          },
          header: 'Browser support',
          width: '30%'
        });
      }
    //}
  }
  ngOnInit() {
    //if (this.auth.userProfile)
      this.checkChrome();
      //else this.auth.userProfileObserver.subscribe(o => {
       // this.checkChrome();
      //})
    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.loadingRouteConfig = true;
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loadingRouteConfig = false;
      }

      if (event instanceof NavigationStart) {

        var orgIdParam = ';organisationId=';
        var customParamsUsed = false;
        var url = event.url;
        if (event.url.indexOf(orgIdParam) != -1) {
          event.url.substring(event.url.indexOf(orgIdParam) + orgIdParam.length, event.url.indexOf(orgIdParam) + orgIdParam.length + 36)
          var curAuth = this.auth.currentOrganisationId;
          this.auth.currentOrganisationId = event.url.substring(event.url.indexOf(orgIdParam) + orgIdParam.length, event.url.indexOf(orgIdParam) + orgIdParam.length + 36);
          customParamsUsed = true;
          url = url.replace(orgIdParam + this.auth.currentOrganisationId, '')
          if (curAuth != this.auth.currentOrganisationId) {
            this.messageService.info('Swithing division ' + (this.auth.currentOrganisation ? 'to ' + this.auth.currentOrganisation.label:''), 'Switching division')
          }
        }

        if (event.url.indexOf("primaryUrl") != -1) {
          this.loadingRouteConfig = true;
          window.location.href = 'https://' + event.url.replace("primaryUrl", appSettings.primaryUrl) + ';organisationId=' + this.auth.currentOrganisationId;
          return;
        }
        if (event.url.indexOf("requisition/index") != -1) {
          this.loadingRouteConfig = true;
          window.location.href = 'https://' + appSettings.primaryUrl + '/' + event.url + ';organisationId=' + this.auth.currentOrganisationId;;
          return;
        }
        if (event.url.indexOf("/callback") == -1 && event.url.indexOf("/#id_token") == -1) {
          this.storage.set(STORAGE_KEY_REDIRECT, event.url);
        }
        this.loadingRouteConfig = true
        this.breadCrumbService.breadcrumbs = new Array();

        var self = this;
        if (customParamsUsed) {
          setTimeout(() => {
            self.router.navigateByUrl(url);
          }, 1)
          return;
        }
      }
      if (event instanceof NavigationEnd) {
        this.loadingRouteConfig = false
      }

      // Set loading state to false in both of the below events to hide the spinner in case a request fails
      if (event instanceof NavigationCancel) {
        this.loadingRouteConfig = false
      }
      if (event instanceof NavigationError) {
        this.loadingRouteConfig = false
      }
    });

  }


  private subscribeToEvents(): void {
    //this.signalRService.connectionEstablished.subscribe(() => {
    //  console.log('app connection established');
    //});

    this.signalRService.newNotification.subscribe((message: any) => {
      //console.log(message);
    });
  }



}
